<nav class="header-shadow navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img
        alt="logo"
        id="logo-sigvaris-group"
        src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4"
      />
    </a>
    <div
      class="collapse navbar-collapse justify-content-start"
      style="margin-left: 10px"
    >
      <ul class="navbar-nav mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active fw-bold" [routerLink]="['en-us/orders']"
            >Orders</a
          >
        </li>
      </ul>
    </div>

    <div class="nav-item dropdown" style="margin-right: 12px;">
      <a
        class="nav-link"
        href="#"
        id="languageDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        @if (selectedLanguage) {
          <span
        [ngClass]="selectedLanguage.flagTag"
        style="margin-right: 12px"
          ></span>
        }
      </a>
      <ul class="dropdown-menu text-center" aria-labelledby="languageDropdown" style="min-width: 10px">
        <li
          *ngFor="let language of languages"
          (click)="onLanguageChange(language)"
          [ngClass]="{ 'selected-language': language === selectedLanguage }"
          style="
            display: flex;
            align-items: center;
            padding: 5px 10px;
            cursor: pointer;
          "
          class="dropdown-item"
        >
          <span [ngClass]="language.flagTag"></span>
        </li>
      </ul>
    </div>

    @if (isTherapist && clinics.length > 1) {
      <select
        class="form-select form-select-sm"
        style="max-width:200px; font-size:13px; margin-right:12px;"
        [value]="selectedClinicId"
        (change)="onClinicChange($event)"
      >
        <option *ngFor="let clinic of clinics" [value]="clinic.id">{{ clinic.name }}</option>
      </select>
    }

    <a
      class="j7 j8 an j9 ja ft fu bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2"
      data-scope-link="true"
      href="/en-us/order-creation"
      >New Order</a
    >

    <div class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle no-caret"
        href="#"
        id="userDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          src="../../../assets/user.png"
          alt="User"
          style="margin-top: 0px; margin-left: 15px; margin-right: 15px"
        />
      </a>
      <ul
        class="dropdown-menu dropdown-menu-end"
        aria-labelledby="userDropdown"
      >
        <li>
          <button class="btn ms-2" (click)="logout()">Logout</button>
        </li>
      </ul>
    </div>
  </div>
</nav>
